import Vue from 'vue'
import Vuetify, { VLayout } from 'vuetify/lib'
import 'vuetify/src/stylus/app.styl'
// import 'vuetify/src/styles/main.sass'

Vue.use(Vuetify, {
  theme: {
    primary: '#027689',
    secondary: '#1F2532',
    accent: '#73E5FF',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107',
    itoviBlueDarkest: '#1F2532',
    itoviBlueDark: '#027689',
    itoviBlue: '#73E5FF',
    itoviGrayLight: '#B3B3B3',
    itoviGrayMid: '#707070',
    itoviBlueGray: '#A0C6C6'
  },
  options: {
    customProperties: true,
    minifyTheme: function (css) {
      return process.env.NODE_ENV === 'production'
          ? css.replace(/[\s|\r\n|\r|\n]/g, '')
          : css
    }
  },
  components: {
    VLayout
  },
  iconfont: 'md',
})
